<!-- 为同事预登记 -->
<template>
  <div class="menu-item-r">
    <div class="gPreReg" v-loading="loading">
        <div class="todo" v-if="$routeName !== 'Voucher'">
            <el-button type="primary" size="small" @click="startForm()"><i class="el-icon-circle-plus-outline"></i>&nbsp;{{$t('gPreReg.addButton')}}</el-button>
        </div>

        <!-- 个人信息 -->
        <div class="body">
            <el-table
                :data="tableData"
                border>
                <el-table-column
                    :label="$t('gPreReg.table.name')"
                    align="center"
                    prop="name"
                    width="120"></el-table-column>
                <el-table-column
                    :label="$t('gPreReg.table.email')"
                    align="center"
                    prop="email"></el-table-column>
                <el-table-column
                    :label="$t('gPreReg.table.confirmation')"
                    align="center"
                    width="180">
                    <template slot-scope="scope" v-if="scope.row.auditState === 'APPROVE'">
                        <div class="lazy-img-fadein" @click="dialogConfirmationShow(scope.row)">
                            <span class="iconfont iconxiazai"></span>
                            <p>{{ $t('Download Confirmation') }}</p>
                        </div>
                        <!-- <el-tooltip class="item" effect="dark" :content="$t('buttons.download')" placement="top">
                            <img v-lazy="imgTemplate2" class="lazy-img-fadein" @click="dialogConfirmationShow(scope.row)" style="width: 54px;" />
                        </el-tooltip> -->
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('gPreReg.table.badge')"
                    align="center"
                    prop="badge"
                    width="170">
                    <template slot-scope="scope" v-if="scope.row.auditState === 'APPROVE'">
                        <el-tooltip class="item" effect="dark" :content="$t('buttons.download')" placement="top">
                        <div class="card-img-box" @click="dialogBadgeShow(scope.row)">
                            <div class="card-img">
                                <img v-lazy="badgeCard"  class="lazy-img-fadein"/>
                            </div>
                        </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('gPreReg.table.createTime')"
                    align="center"
                    width="150">
                    <template slot-scope="scope">
                        <span class="font-size-13">{{$funcs.dateFormat(scope.row.createTime, 'YYYY-mm-dd HH:MM:SS')}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    :label="$t('gPreReg.table.status')"
                    align="center"
                    prop="status"
                    width="120">
                    <template slot-scope="scope">
                        <template v-if="scope.row.auditState === 'APPROVE'">
                            <span class="theme-tag theme-tag-small theme-icon-blue theme-tag-no-ml">{{$t('buttons.examineText[3]')}}</span>
                        </template>
                        <template v-else>
                            <span class="theme-tag theme-tag-small theme-tag-error theme-tag-no-ml">{{ scope.row.auditState === 'PENDING' ? $t('buttons.examineText[1]') : $t('buttons.examineText[2]') }}</span>
                        </template>
                    </template>  
                </el-table-column> -->
                <!-- <el-table-column
                    :label="$t('buttons.operation')"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        <el-link type="primary" v-if="scope.row.auditState === 'DISAPPROVE'" class="color-blue" @click="startForm(scope.row.id)">{{ $t('buttons.edit') }}</el-link>
                    </template>  
                </el-table-column> -->
            </el-table>
            <div class="margin-t-24" v-if="$routeName !== 'Voucher'">
                <el-pagination
                    v-if="tableData.length > 0"
                    background
                    @current-change="handleCurrentChange"
                    :page-size="query.pageRows"
                    :current-page.sync="query.pageNum"
                    layout="total, prev, pager, next, jumper"
                    :total="query.total"
                    class="bl-page">
                </el-pagination>
            </div>
        </div>

        <!-- 下载胸卡 -->
        <winDialog
            top="6vh"
            :dialogShow.sync="dialogBadge"
            :title="dialogBadgeTitle"
            :subTitle="dialogBadgeSubTitle"
            :showFooter="false">
            <template v-slot:bodyContent>
                <div class="vip-card-body">
                    <div class="vid-card-block" ref="vidCardBlock">
                        <!-- <div class="vip-card">
                            <div class="vip-card__body vip-card__body2">
                                <div class="vip-card__body-left">
                                    <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/logo.png" class="card-logo" />
                                    <div class="text">{{curItem.name}}</div>
                                    <div class="text2">{{curItem.corporateName}}</div>
                                    <img class="barcode" id="barcode" />
                                </div>
                                <div class="vip-card__body-right">
                                    <div class="text">43<sup>rd</sup></div>
                                    <div class="img-head">
                                        <img src="../../assets/images/watermark.png" class="watermark" />
                                        <img :src="curItem.headImage"  class="img" />
                                    </div>
                                </div>
                            </div>
                            <div class="vip-card__foot">{{curItem.countryId == 86 ? $t('gPreReg.PurChasing-Agent') : $t('gPreReg.BUYER')}}</div>
                        </div> -->
                        <div class="vip-badge-card">
                            <img :src="badgeCardBig">
                            <div class="qrCodeDiv1" ref="qrCodeDiv1" id="qrCodeDiv1"></div>
                            
                            <div class="vip-badge-card-info">
                                <p><span>{{$t('name')}}</span>{{curItem.name}}</p>
                                <p><span>{{$t('badgeCard')}}</span>{{curItem.cardNumber}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="vip-todo">
                        <el-button type="primary" class="no-radius" :loading="loadingVipStart" @click="startDownLoad('card-down')">{{$t('vip.downloadStart')}}</el-button>
                    </div>
                </div>
            </template>
        </winDialog>

        <!-- 下载确认函 -->
        <winDialog
            top="6vh"
            :dialogShow.sync="dialogConfirmation"
            :title="dialogBadgeTitle"
            :subTitle="dialogBadgeSubTitle"
            :showFooter="false">
            <template v-slot:bodyContent>
                <template>
                    <div class="tem_box" ref="querenBlock">
                        <div class="tem_body">
                            <div class="tem_head">
                                <img v-lazy="cardBanner" />
                            </div>
                            <div class="tem_content">
                                <div class="tem_content--body">
                                    <div class="tem_content--body_box">
                                        <div class="margin-t-24 font-size-18 f-w-b text-center color-black">{{ curItem.name }}</div>
                                        <div class="margin-t-8 font-size-14 m-b-24 f-w-b text-center">{{ curItem.corporateName }}</div>
                                        <div class="p-10 m-10 bg-light9">
                                            <div class="m-t-b-16 font-size-18 f-w-b text-center">{{ curItem.cardNumber}}</div>
                                            <div class="text-center qrCodeDiv" ref="qrCodeDiv" id="qrCodeDiv"></div>
                                            <div class="m-t-b-16 font-size-14 f-w-b text-center">{{ $t('gPreReg.groupTips1') }}</div>
                                        </div>
                                        
                                        <div class="margin-t-24 font-size-14 f-w-b text-center">{{ $t('gPreReg.groupTips2') }}</div>
                                        <div class="font-size-14 p-b-24 f-w-b text-center">{{ $t('gPreReg.groupTips3') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vip-todo">
                        <el-button type="primary" class="no-radius" :loading="loadingVipStart" @click="startDownLoad('queren-down', 'querenBlock')">{{$t('vip.downloadStart')}}</el-button>
                    </div>
                </template>
            </template>
        </winDialog>
    </div>
  </div>
</template>

<script>
import { teamList} from '@/api/groupPreRegistration'
import { mapGetters } from 'vuex'
import winDialog from '@/components/dialog/dialog'
import imgTemplate from '@/assets/images/badge.png'
import imgTemplate2 from '@/assets/images/yaoqinghan.jpg'
import downCardMixin from '@/mixins/downCard.js'
// import cardBanner from '@/assets/images/cardBanner.png'
// import badgeCard from '@/assets/images/badgeCard.png'
// import badgeCardBig from '@/assets/images/badgeCardBig.png'

export default {
  data () {
    // 这里存放数据
    return {
        query: {
            pageNum: 1,
            pageRows: 10,
            total: 0
        },
        badgeCardBig: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/banner/badgeCardBig.png',
        badgeCard: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/banner/badgeCard.png',
        cardBanner: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/banner/cardBanner.png',
        imgTemplate,
        imgTemplate2,
        loading: false,
        tableData: [],
        dialogBadge: false,
        dialogConfirmation: false,
        dialogBadgeTitle: '',
        dialogBadgeSubTitle: '',
        loadingVipStart: false,
        curItem: {},
        label: {
            'exhibitionName': ['第43届广州（锦汉）家居用品及礼品展', 'The 43<sup>rd</sup> Beijing International High-tech Exop for Home & Gifts'],
            'subTitle': ['采购代表电子邀请确认函', 'BUYER PRE-REGISTRATION CONFIRMATION'],
            'dear': ['尊敬的', 'Dear'],
            'text': ['您已成功进行第43届广州（锦汉）家居用品及礼品展会采购代表预登记，请打印此确认函，并携带您的名片和身份证明文件，前往展会现场办证处换领入场证件。',
            'Your pre-registration for the 43<sup>rd</sup> Beijing International High-tech Exop for Home & Gifts is well received. Please print out this confirmation letter and present it to obtain the Buyer Badge at the Pre-registered Counter of Registration Center on site. Your pre-registration information is as follow:'],
            'info': ['您的预登记信息如下:'],
            'name': ['姓名', 'Name'],
            'counry': ['', 'Counry/Region'],
            'company': ['公司名称', 'Company Name'],
            'yaoqinghan': ['邀请函须知', 'Please note that this confirmation is valid ONLY with the following TWO documents:'],
            'yaoqinghan2': ['请打印本电子邀请函，持电子确认函，并携带您的名片和身份证明文件，前往展会现场办证处换领入场证件。', '• Overseas passport / Hong Kong or Macao I.D. Card / HK or Macau Residence Permit / Taiwan Compatriot Travel Certificate <br/>• Business Card (two) with your own information This confirmation is not transferrable. It must be used by the applicant himself/herself. The Beijing International High-tech Exop organizer reserves the final right of explanation for the badge regulations.'],
            'yaoqinghan3': ['为确保电子邀请函持有人权益，该电子邀请函的使用人必须是被邀请者本人（被邀请人资料存档于展会系统中），否则电子邀请函无效', 'This confirmation is not transferrable. It must be used by the applicant himself/herself. The Beijing International High-tech Exop organizer reserves the final right of explanation for the badge regulations'],
            'addressTitle': ['展会地址', 'Fair Venue'],
            'address': ['广州市海珠区新港东路1000号保利世贸博览馆', 'Poly World Trade Center Expo, Guangzhou (Opposite to Area B, Beside Area C of Canton Fair) 1000, Xingangdong Road, Haizhu District, Guangzhou, P.R.China'],
            'address2': ['（地铁琶洲站C出口，临近广交会C馆）'],
            'footTitle': ['第43届广州（锦汉）家居用品及礼品展览会成汁邀请您的参与！', 'We look forward to seeing you at Beijing International High-tech Exop!']
        }
    }
  },
  mixins: [downCardMixin],
  components: {
    winDialog
  },
  computed: {
    ...mapGetters(['info', 'language']),
    ...{
        $routeName() {
            return this.$route.name
        }
    }
  },
  mounted () {
    this.pageInit()
  },
  methods: {
    // 开始预登记
    startForm(id) {
        if (id) {
            // 编辑
            this.$router.push(`/preRegistration/index/${id}`)
        } else {
            // 新建
            this.$router.push("/preRegistration/index")
        }   
    },
    // 入场凭证
    voucherData() {
        if (this.info) {
            this.tableData = [this.info.visitor]
        }
    },
    // 页面初始化
    pageInit() {
        this.loading = true
        if (this.$routeName === 'Voucher') {
            this.voucherData()
            this.loading = false
        } else {
            teamList().then(res => {
                return res.data
            }).then(res => {
                this.tableData = res.data.list || []
                this.query.total = res.data.total || 0
                this.query.pages = res.data.pages || 0
            }).finally(() => {
                this.loading = false
            })
        }
    },
    // 胸卡弹框
    dialogBadgeShow(data) {
        let card = data.cardNumber
        if (!card) {
            this.$notify.error({
                message: this.$t("vip.cardNumberEmpty")
            })
            return
        }
        this.dialogBadgeTitle = this.$t('gPreReg.dialogBadgeTitle')
        this.dialogBadgeSubTitle = this.$t('gPreReg.dialogBadgeSubTitle')
        this.dialogBadge = true
        this.curItem = data
        // this.createJsbarcode(card, null)
        this.createQRCode(card, 'qrCodeDiv1')
    },
    // 确认函弹框
    dialogConfirmationShow(data) {
        console.log(data)

        let card = data.cardNumber
        if (!card) {
            this.$notify.error({
                message: this.$t("vip.cardNumberEmpty")
            })
            return
        }
        this.dialogBadgeTitle = this.$t('gPreReg.dialogCTitle')
        this.dialogBadgeSubTitle = this.$t('gPreReg.dialogCSubTitle')
        this.dialogConfirmation = true
        this.curItem = data
        this.createQRCode(card, 'qrCodeDiv')
        // this.createJsbarcode(card, "#fbfbfb", '#barcode2')
    },
    // 获取邀请函
    getText(name) {
        let c = this.curItem.countryId == 86 ? true : false;
        return c ? this.label[name][0] : this.label[name][1]
    },
    // 分页
    handleCurrentChange(page) {
        this.query.pageNum = page
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/styles/pages/badge'
@import '~@/styles/pages/confirmationLetter'

.iconxiazai{
    font-size: 32px;
    color $color-main
    margin-bottom 16px    
}

.vip-todo {
    margin-top: 40px;
    text-align: center;

    >>> .el-button {
        width: 320px;
    }
}

.gPreReg {
    margin: 30px auto;
    padding: 24px 24px 70px;
    background: $color-gray-fb;

    .todo {
        margin-bottom: 24px;
        text-align: right;
    }

    >>> .el-table {
        .el-table__header-wrapper,
        .el-table__footer-wrapper {
            background: $color-gray-f1;
        }

        th {
            font-size: 14px;
            color: $color-gray-85;
            background: $color-gray-f1;
        }

        tr {
            background: $color-gray-fb;
        }
    }

    .card-img-box {
        position: relative;
        padding: 0;
        // background: $color-main;
        color: $color-black;
        font-weight: 700;
        cursor: pointer;
        border: 1px solid $color-white;
        overflow: hidden;
        transition: all .3s;

        // &:hover {
        //     border-color: $color-main;
        // }

        .card-img__head {
            position: absolute;
            right: 6px;
            bottom: 33px;
            width: 44px;
            height: 56px;
            background: $color-gray-d9;
            object-fit: cover;
            z-index: 10
        }

        .card-userInfo {
            position: absolute;
            top: 22px;
            left: -23px;
            width: 150px;
            font-size: 12px;
            font-weight: 500;
            text-align: left;
            line-height: 1.4;
            transform: scale(0.6);
            color: $color-gray-65;
            z-index: 11;
        }

        .card-img-text {
            height: 22px;
            line-height: 22px;
        }

        .card-img-text2 {
            margin-left: -7px;
            white-space: nowrap;
            transform: scaleX(.8);
            font-size: 12px;
        }
    }
}
</style>
<style lang="stylus">
#qrCodeDiv{
    margin auto !important
    img{
        margin 0 auto !important
        text-align: center !important
    }
}
#qrCodeDiv1{
    position: absolute;
    width: 78px;
    height: 80px;
    bottom: 59px;
    left: 40px;
    border: 1px solid;
    padding: 3px 2px 2px 2px;
}
</style>
